import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { PageHead, Modal, Field, inp } from "../../components/admin/AdminBits";
import { Plus, Pencil, Trash2, Ticket } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { code: "", type: "percent", value: 10, active: true, min_order: 0, max_uses: 0, expires_at: "" };

export default function AdminCoupons() {
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/admin/coupons").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (edit.id) await api.put(`/admin/coupons/${edit.id}`, edit);
      else await api.post("/admin/coupons", edit);
      toast.success("Запазено"); setEdit(null); load();
    } catch { toast.error("Грешка"); }
  };
  const del = async (id) => { if (window.confirm("Изтриване?")) { await api.delete(`/admin/coupons/${id}`); load(); } };

  return (
    <div data-testid="admin-coupons">
      <PageHead title="Купони" desc="Създавайте промо кодове с процентна или фиксирана отстъпка."
        action={<button onClick={() => setEdit({ ...EMPTY })} className="btn-gold px-4 py-2.5 rounded-sm text-sm flex items-center gap-2" data-testid="add-coupon-btn"><Plus size={16} /> Нов купон</button>} />
      <div className="bg-white border border-stone overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-stone text-navy"><tr><th className="text-left p-3">Код</th><th className="text-left p-3">Отстъпка</th><th className="text-left p-3">Мин. поръчка</th><th className="text-left p-3">Употреби</th><th className="text-left p-3">Активен</th><th className="p-3"></th></tr></thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} className="border-t border-stone" data-testid={`coupon-${c.code}`}>
                <td className="p-3 font-mono text-navy font-semibold flex items-center gap-2"><Ticket size={14} className="text-gold" />{c.code}</td>
                <td className="p-3">{c.type === "percent" ? `${c.value}%` : `${c.value} €`}</td>
                <td className="p-3">{c.min_order || 0} €</td>
                <td className="p-3">{c.used_count || 0}{c.max_uses ? ` / ${c.max_uses}` : ""}</td>
                <td className="p-3">{c.active ? <span className="text-green-600">Да</span> : <span className="text-charcoal/40">Не</span>}</td>
                <td className="p-3 text-right"><div className="flex justify-end gap-2"><button onClick={() => setEdit(c)} className="text-navy hover:text-gold"><Pencil size={15} /></button><button onClick={() => del(c.id)} className="text-charcoal/40 hover:text-red-500"><Trash2 size={15} /></button></div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {edit && (
        <Modal title={edit.id ? "Редакция" : "Нов купон"} onClose={() => setEdit(null)}>
          <form onSubmit={save}>
            <Field label="Код" hint="Остави празно за автоматичен"><input value={edit.code} onChange={(e) => setEdit({ ...edit, code: e.target.value.toUpperCase() })} className={inp} placeholder="SUMMER20" data-testid="coupon-code" /></Field>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Тип"><select value={edit.type} onChange={(e) => setEdit({ ...edit, type: e.target.value })} className={inp}><option value="percent">Процент %</option><option value="fixed">Фиксирана €</option></select></Field>
              <Field label="Стойност"><input type="number" value={edit.value} onChange={(e) => setEdit({ ...edit, value: e.target.value })} className={inp} data-testid="coupon-value" /></Field>
              <Field label="Мин. поръчка (€)"><input type="number" value={edit.min_order} onChange={(e) => setEdit({ ...edit, min_order: e.target.value })} className={inp} /></Field>
              <Field label="Макс. употреби (0=∞)"><input type="number" value={edit.max_uses} onChange={(e) => setEdit({ ...edit, max_uses: e.target.value })} className={inp} /></Field>
            </div>
            <Field label="Изтича на"><input type="date" value={edit.expires_at?.slice(0,10) || ""} onChange={(e) => setEdit({ ...edit, expires_at: e.target.value })} className={inp} /></Field>
            <label className="flex items-center gap-2 text-sm text-navy mb-3"><input type="checkbox" checked={edit.active} onChange={(e) => setEdit({ ...edit, active: e.target.checked })} className="accent-[#C6A45C]" /> Активен</label>
            <button type="submit" className="btn-gold w-full py-2.5 rounded-sm" data-testid="save-coupon-btn">Запази</button>
          </form>
        </Modal>
      )}
    </div>
  );
}
